import { render, staticRenderFns } from "./m-title.vue?vue&type=template&id=54404472&scoped=true&"
import script from "./m-title.vue?vue&type=script&lang=ts&"
export * from "./m-title.vue?vue&type=script&lang=ts&"
import style0 from "./m-title.vue?vue&type=style&index=0&id=54404472&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54404472",
  null
  
)

export default component.exports